module.exports = __webpack_public_path__ + "static/img/best_smile.72f3df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sumire/img/best_smile.png
// module id = YKgR
// module chunks = 2